var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "brand" },
    [
      _c("tree-transfer", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loadClassify,
            expression: "loadClassify"
          }
        ],
        attrs: {
          title: _vm.transTitle,
          from_data: _vm.fromData,
          to_data: _vm.toData,
          pid: "c_parent",
          mode: _vm.mode,
          height: "540px",
          filter: ""
        },
        on: { addBtn: _vm.add, removeBtn: _vm.remove }
      }),
      _vm._v(" "),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.saveClassify } },
        [_vm._v("保存")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce97976e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce97976e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/basic/classify.vue
// module id = null
// module chunks = 